import { render } from "./add-leave.vue?vue&type=template&id=7732d7ae"
import script from "./add-leave.vue?vue&type=script&lang=js"
export * from "./add-leave.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__